<div class="wrap">
  <div class="selected-mode">
    <div class="other" (click)="togglePaymentMode()" matRipple>
      <div class="text">PAY USING</div><div class="icon"><app-icon [name]="'arrow_drop_down'" [size]="8" /></div>
    </div>
    <div class="label-icon"><div class="icon {{payment.selectedModeValue}}"></div><div class="label">{{payment.selectedPaymentModeLabel}}</div></div>
  </div>
  <div class="action-btn">
    <button type="submit" [disabled]="isLoading" matRipple>
      <ng-container *ngIf="!isLoading">
        Contribute <app-currency-icon [currency]="currency" />{{amount}}
      </ng-container>
      <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </button>
  </div>
</div>